// extracted by mini-css-extract-plugin
export default {"card":"Q9xSu8","petInfo":"bgX5ZQ","petName":"BS4uhc"};